<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  emits: ["stored"],

  data() {
    return {
      isVisible: false,
      isLoading: false,
      mode: "tambah",
      editId: null,
      originalBobot: 0,
      form: {
        indikator: "",
        bobot: "",
        is_active: 0,
      },
      indikatorOptions: [
        { value: "noise-detected", text: "Noise" },
        { value: "no-face-looking-at-camera", text: "Multiple Faces" },
        { value: "tab-focus-lost", text: "Tab Switch" },
        { value: "multiple-monitors", text: "Multiple Monitors" },
        { value: "random-photo-taken", text: "Random Photos" },
        { value: "fullscreen-exited", text: "Enforce Full Screen" },
      ],
    };
  },

  computed: {
    modalTitle() {
      return this.mode === "edit" ? "Edit Config Proctoring" : "Tambah Config Proctoring";
    },
  },

  methods: {
    open(rowData = null) {
      if (rowData) {
        this.mode = "edit";
        this.editId = rowData.idconfig_proctoring;
        this.originalBobot = Number(rowData.bobot) || 0;
        this.form = {
          indikator: rowData.label,
          bobot: Number(rowData.bobot) || 0,
          is_active: rowData.is_active,
        };
      } else {
        this.mode = "tambah";
        this.editId = null;
        this.originalBobot = 0;
        this.form = { indikator: "", bobot: "", is_active: 0 };
      }
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },

    async store() {
      if (!this.form.indikator) {
        Swal.fire("Peringatan", "Indikator wajib dipilih", "warning");
        return;
      }
      if (this.form.bobot === "" || this.form.bobot === null) {
        Swal.fire("Peringatan", "Bobot wajib diisi", "warning");
        return;
      }

      this.isLoading = true;

      // cek total bobot existing di DB
      let totalBobotExisting = 0;
      try {
        const checkRes = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/config-proctoring/total-bobot",
          method: "get",
          headers: { Authorization: `Bearer ${localStorage.access_token}` },
        });
        totalBobotExisting = checkRes?.data?.data?.total_bobot ?? 0;
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Gagal memvalidasi total bobot",
          showConfirmButton: true,
        });
        this.isLoading = false;
        return;
      }

      // saat edit, kurangi bobot lama record ini dari total agar tidak dihitung dua kali
      const bobotLainnya =
        this.mode === "edit"
          ? Number(totalBobotExisting) - this.originalBobot
          : Number(totalBobotExisting);

      const totalSetelahSimpan = bobotLainnya + Number(this.form.bobot);
      if (totalSetelahSimpan > 100) {
        const sisaBobot = 100 - bobotLainnya;
        Swal.fire(
          "Peringatan",
          `Total bobot tidak boleh melebihi 100%. Bobot lainnya: ${bobotLainnya}%. Sisa bobot yang tersedia: ${sisaBobot}%.`,
          "warning"
        );
        this.isLoading = false;
        return;
      }

      const selectedOption = this.indikatorOptions.find((o) => o.value === this.form.indikator);
      axios({
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/config-proctoring",
        method: "post",
        data: {
          id: this.editId,
          indikator: selectedOption?.text ?? this.form.indikator,
          label: this.form.indikator,
          bobot: this.form.bobot,
          is_active: this.form.is_active,
        },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          let meta = res?.data?.meta;
          if (meta?.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: meta.message || "Data berhasil disimpan",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            });
            this.close();
            this.$emit("stored");
          } else {
            Swal.fire("Peringatan", meta?.message || "Terdapat kendala saat menyimpan data", "warning");
          }
        })
        .catch((err) => {
          console.log(err);
          let meta = err?.response?.data?.meta;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `${meta?.message || "Terjadi kesalahan pada sistem"}`,
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="isVisible"
    :title="modalTitle"
    title-class="fw-bold"
    hide-footer
    no-close-on-backdrop
    centered
  >
    <form @submit.prevent="store">
      <!-- Indikator -->
      <div class="mb-3">
        <label class="form-label fw-semibold">Indikator <span class="text-danger">*</span></label>
        <select
          v-model="form.indikator"
          class="form-select"
          :disabled="isLoading"
        >
          <option value="" disabled>-- Pilih Indikator --</option>
          <option
            v-for="opt in indikatorOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
      </div>

      <!-- Bobot -->
      <div class="mb-3">
        <label class="form-label fw-semibold">Bobot (%) <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            v-model.number="form.bobot"
            type="number"
            class="form-control"
            placeholder="0"
            min="0"
            max="100"
            step="1"
            :disabled="isLoading"
          />
          <span class="input-group-text">%</span>
        </div>
      </div>

      <!-- Status -->
      <div class="mb-4">
        <label class="form-label fw-semibold d-block">Status</label>
        <div class="d-flex align-items-center gap-2">
          <label class="mySwitch mb-0">
            <input
              type="checkbox"
              :checked="form.is_active == 1"
              :disabled="isLoading"
              @change="form.is_active = $event.target.checked ? 1 : 0"
            />
            <span class="mySlider"></span>
          </label>
          <span class="badge py-2" :class="form.is_active == 1 ? 'bg-success' : 'bg-secondary'">
            {{ form.is_active == 1 ? "Aktif" : "Tidak Aktif" }}
          </span>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <b-button type="button" variant="secondary" size="sm" :disabled="isLoading" @click="close">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" size="sm" :disabled="isLoading">
          <i v-if="isLoading" class="fas fa-spinner fa-spin me-1"></i>
          <i v-else class="fa fa-save me-1"></i>
          Simpan
        </b-button>
      </div>
    </form>
  </b-modal>
</template>
